import { SVG_NS } from './constants';

/**
 * 将 SVG 字符串编码成 data URL。
 *
 * @param svgText - 完整 SVG 字符串。
 * @returns 可交给图片加载器使用的 SVG data URL。
 */
export const createSVGDataURL = (svgText: string): string =>
    `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svgText)}`;

/**
 * 将 SVG 根节点序列化为文本和对应的 data URL。
 *
 * @param svg - 需要序列化的 SVG 根节点。
 * @returns SVG 文本和可加载的 data URL。
 */
export const serializeSVG = (svg: SVGSVGElement): { svgText: string; dataURL: string } => {
    const svgText = new XMLSerializer().serializeToString(svg);
    return { svgText, dataURL: createSVGDataURL(svgText) };
};

/**
 * 克隆 SVG 并在最外层内容分组应用图层透明度后序列化。
 *
 * 原 SVG 不会被修改；透明度为 1 或无效值时不增加冗余分组。
 *
 * @param svg - 不包含图层外层透明度的 SVG 根节点
 * @param opacity - 图层外层透明度
 * @returns 包含图层外层透明度的 SVG 文本和对应 data URL
 */
export const serializeSVGWithOpacity = (svg: SVGSVGElement, opacity: number): { svgText: string; dataURL: string } => {
    const normalizedOpacity = Number.isFinite(opacity) ? Math.max(0, Math.min(1, opacity)) : 1;
    if (normalizedOpacity === 1) return serializeSVG(svg);

    const clonedSvg = svg.cloneNode(true) as SVGSVGElement;
    const opacityGroup = clonedSvg.ownerDocument.createElementNS(SVG_NS, 'g');
    opacityGroup.setAttribute('opacity', String(normalizedOpacity));

    while (clonedSvg.firstChild) {
        opacityGroup.appendChild(clonedSvg.firstChild);
    }
    clonedSvg.appendChild(opacityGroup);

    return serializeSVG(clonedSvg);
};
